export type Mode = 'goal' | 'endless';

export interface ChainLink {
  word: string;
  overlapFromPrevious: string;
}

export interface WordDominoesLevel {
  mode?: string;
  startWord?: string;
  targetWord?: string;
  overlapLength?: number;
  moveLimit?: number;
  parChainLength?: number;
  difficulty?: string;
  acceptedWords?: string[];
  solverPath?: string[];
}

export interface NormalizedWordDominoes {
  mode: Mode;
  startWord: string;
  targetWord: string | null;
  overlapLength: number;
  moveLimit: number;
  parChainLength: number;
  acceptedWords: Set<string>;
  solverPath: string[];
}

export function normalize(level: WordDominoesLevel): NormalizedWordDominoes | null {
  const startWord = (level.startWord ?? '').toUpperCase();
  if (!startWord) return null;
  const mode: Mode = (level.mode as Mode) === 'endless' ? 'endless' : 'goal';
  const target = level.targetWord ? level.targetWord.toUpperCase() : null;
  if (mode === 'goal' && !target) return null;
  const overlap = level.overlapLength ?? 2;
  if (overlap !== 2 && overlap !== 3) return null;
  const moveLimit = level.moveLimit ?? 8;
  const par = level.parChainLength ?? Math.max(1, moveLimit - 2);
  const accepted = new Set((level.acceptedWords ?? []).map((w) => w.toUpperCase()));
  const solver = (level.solverPath ?? []).map((w) => w.toUpperCase());
  return {
    mode,
    startWord,
    targetWord: target,
    overlapLength: overlap,
    moveLimit,
    parChainLength: par,
    acceptedWords: accepted,
    solverPath: solver,
  };
}

/** Returns valid prefix options (longest first) the next word may begin with. */
export function validPrefixes(lastWord: string): string[] {
  const out: string[] = [];
  if (lastWord.length >= 3) out.push(lastWord.slice(-3));
  if (lastWord.length >= 2) out.push(lastWord.slice(-2));
  return out;
}
